import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useState, useContext, useEffect } from 'react';
import { Stack, Button, Container, Typography, Box } from '@mui/material';
import Iconify from '../components/iconify';
import { RoleList, UserList } from '../sections/role';
import { authContext } from '../routes';
import { UserUpdateForm } from '../sections/user';
import UserPaymentInfo from '../sections/common/UserPaymentInfo';

export default function RolePage() {
  const { user } = useContext(authContext);
  const [roleActivatedOn, setRoleActivatedOn] = useState('list');
  const [userToBeUpdated, setUserToBeUpdated] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      const expirationDate = new Date(decodedToken.exp * 1000);
      if (expirationDate < new Date()) {
        localStorage.clear();
        navigate('/login');
      } else if (user && !user.role.permissions.role.create) {
        navigate('/dashboard');
      }
    } else {
      navigate('/login');
    }
  }, [navigate, user]);

  return (
    <>
      <Helmet>
        <title> ሚና | የሰ/ሸ/ሃ/መ/አ/ስርዓት </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography sx={{ display: { xs: 'none', sm: 'block' } }} color="text.secondary" variant="h4" gutterBottom>
            ሚና
          </Typography>
          <Typography sx={{ display: { xs: 'block', sm: 'none' } }} color="text.secondary" variant="h4" gutterBottom>
            <Iconify icon="carbon:badge" />
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'right', gap: { xs: 1, sm: 2 } }}>
            <Button
              disabled={roleActivatedOn === 'list'}
              variant="contained"
              startIcon={<Iconify icon="eva:list-fill" />}
              onClick={() => setRoleActivatedOn('list')}
              color="success"
            >
              <Typography sx={{ display: { xs: 'none', sm: 'block' } }}>የሚና ዝርዝር</Typography>
            </Button>
          </Box>
        </Stack>

        {roleActivatedOn && roleActivatedOn === 'list' && (
          <RoleList setUserToBeUpdated={setUserToBeUpdated} setRoleActivatedOn={setRoleActivatedOn} />
        )}

        {user && roleActivatedOn && roleActivatedOn === 'userList' && userToBeUpdated && (
          <UserList
            userToBeUpdated={userToBeUpdated}
            setUserToBeUpdated={setUserToBeUpdated}
            setRoleActivatedOn={setRoleActivatedOn}
          />
        )}

        {user && roleActivatedOn && roleActivatedOn === 'userUpdate' && userToBeUpdated && (
          <UserUpdateForm userToBeUpdated={userToBeUpdated} setUserToBeUpdated={setUserToBeUpdated} />
        )}
        {roleActivatedOn && userToBeUpdated &&
          roleActivatedOn === 'userPayment' &&
          (
            <UserPaymentInfo userId={userToBeUpdated.id} />
          )}
      </Container>
    </>
  );
}
